"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCrown(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#F8E71C",
    fillRule: "evenodd",
    d: "M4.823 17A45.053 45.053 0 003 7.584l4.758 3.554L12 5l4.242 6.138L21 7.584A44.99 44.99 0 0019.177 17c-4.324-.007-10.03-.007-14.354 0z",
    clipRule: "evenodd"
  }));
}

var MemoSvgCrown = /*#__PURE__*/React.memo(SvgCrown);
var _default = MemoSvgCrown;
exports["default"] = _default;